<template>
  <div>
    <b-container fluid class="pb-5 card-management">
        <b-row>
          <b-col xl="12" class="mb-2">
            <h3 class="pl-3 pt-3">{{ $t('Card Management') }}</h3>
            <div class="p-2 mb-4">
              <div class="row">
                <div class="col-12">
                  <step-container 
                    :current_step="1" 
                    :skip_last="!haveCardFee"
                    :step_list="stepList"
                  ></step-container>
                </div>                
              </div>
              <div class="fz-24 fw-600 p-2">{{ $t('Choose Your Prepaid Card') }}</div>
              <div class="row br-20 mt-4">
                <div v-for="(item,index) in card_option" class="col-lg-6 col-md-12 pb-5">
                  <card-option :data="item"></card-option>
                </div>
              </div>
            </div>

          </b-col>
        </b-row>
    </b-container>
    <LoaderComponent v-if="isLoading"></LoaderComponent>
  </div>
</template>
<script>
  import Common from "@/services/Common";
  import LoaderComponent from "@/components/LoaderComponent";
  import stepContainer from "@/components/CardManagement/stepContainer";
  import cardOption from "@/components/CardManagement/cardOption";
  import Global from '@/services/Global';

  const CARD_TYPE = ['physical'];

  export default {
    name: 'card-management',
    data() {
      return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        isLoading:false,
        haveCardFee:false,
        stepList:["Choose Card Product","Fill in Details", "Payment"],
        card_option:[]
      }
    },
    components: {
      LoaderComponent,
      stepContainer,
      cardOption
    },
    methods:{
      checkError(err){
        try{
          const response = err.response;  
          if(response.status == 401 && response.data.name == "Unauthorized"){
                  localStorage.removeItem("token");
                  localStorage.removeItem("member");
                  localStorage.removeItem("isFirstTime");
                  this.$router.push({ 
                    path: '/login', 
                  });
                }
          else{
            if(localStorage.getItem("token")){
              var msg = (response.data)?response.data.message:err.message;
              this.$notify({
              type: 'warn',
              text: msg
              })
            }
          }
        }catch(e){
          console.log(err);
        }
      }
    },
    mounted(){
      Common.get_fee().then(response => {
        if(response.status==200){
          const data = response.data.data;
          for (let i = 0; i < data.length; i++) {
            if(CARD_TYPE.includes(data[i]['provider']['type'])){
              
              if(parseFloat(data[i].card_fee)>0){
                this.haveCardFee = true;
              }

              this.card_option.push({
                "provider_id":data[i]['provider']['id'],
                "type":data[i]['provider']['type'].charAt(0).toUpperCase() + data[i]['provider']['type'].slice(1),
                "name":data[i]['provider']['name'],
                "image":data[i]['provider']['image'],
                "card_fee":data[i].card_fee,
                "fee":data[i].fee,
                "arrival_duration":parseInt(data[i]["provider"]["arrival_duration"]),
                "currency":"USD",
                "description":"Spend and withdraw money around the world. In your wallet and on your side.",
                "button":parseInt(data[i]["provider"]["arrival_duration"])>0?"Arrive within "+data[i]["provider"]["arrival_duration"]+" days":"Select",
                "is_disabled":false
              });
            }
          }
        }
      }).catch(err => {
        this.checkError(err);
      });
    }
  };
</script>
